import { useContext } from 'react'
import { TextInputWithErrorStyled, TextInputStyled, ErrorStyled } from './TextInput.styles'

import { StoreContext } from '@/components/App'
import { observer } from 'mobx-react'

interface TextInputProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [x: string]: any
  type: 'text' | 'email' | 'password'
  defaultValue?: string
  error?: boolean
  errorMessage?: string
  onChange?: (e) => void
}

export const TextInput = observer(({ type, error, errorMessage, onChange }: TextInputProps) => {
  const store = useContext(StoreContext)
  const { theme } = store.AppState

  const onChangeHandler = (e) => {
    onChange && onChange(e)
  }

  return (
    <TextInputWithErrorStyled>
      <TextInputStyled
        type={type}
        className={error && 'error'}
        {...theme.input}
        onChange={onChangeHandler}
      ></TextInputStyled>
      {error && <ErrorStyled {...theme.input}>{errorMessage}</ErrorStyled>}
    </TextInputWithErrorStyled>
  )
})
